import { render } from "./AttachIso.vue?vue&type=template&id=3f33e0b7&scoped=true"
import script from "./AttachIso.vue?vue&type=script&lang=js"
export * from "./AttachIso.vue?vue&type=script&lang=js"

import "./AttachIso.vue?vue&type=style&index=0&id=3f33e0b7&lang=scss&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f33e0b7"]])

export default __exports__